import { render, staticRenderFns } from "./tableEmptyByParams.vue?vue&type=template&id=22523a8c&scoped=true"
var script = {}
import style0 from "./tableEmptyByParams.vue?vue&type=style&index=0&id=22523a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22523a8c",
  null
  
)

export default component.exports